<template>
  <v-layout
    class="relative"
    style="margin: 40px;box-shadow: rgb(173, 173, 173) 1px -7px 17px -11px;background: rgba(255, 255, 255, 0.82) !important;overflow: hidden;border-radius: 14px 0px 0px 14px;"
  >
    <!--<div style="height: 100%;width: 100%;background: white;position: absolute;z-index: 1;left: 282px;"></div>-->
    <div
      style="height: 100%;width: 300px;background: linear-gradient(25deg, rgba(232, 235, 237, 0) 0%, rgb(255, 255, 255)) 100%;position: absolute;z-index: 1;left: 0px;border-radius: 14px 0px 0px 14px;box-shadow: rgba(173, 173, 173, 0.55) 4px -4px 17px -11px;overflow: hidden;"
    >
      <!--<div style="height: 309px;width: 144%;background: linear-gradient(173deg, rgb(11, 199, 177), rgba(33, 208, 207, 0.95));position: absolute;top: -145px;transform: rotate(184deg);left: -29px;/* border-radius: 167px; *//* box-shadow: inset rgba(148, 148, 148, 0.43) 8px -8px 17px 7px; */"></div>-->
    </div>
    <!--<div style="height: 100px;width: 100%;background: linear-gradient(182deg, rgba(28, 226, 149, 0.95), rgb(9, 194, 132), rgba(15, 171, 121, 0.95));position: absolute;top: -28px;transform: rotate(181deg);z-index:1"></div>-->

    <!--<img src="../../assets/city.png" style="position: absolute;left: -12px;bottom: 0px;z-index: 1;opacity: 0.3;" id="city"/>-->

    <lingo_drawer></lingo_drawer>
    <lingo_toolbar></lingo_toolbar>

    <v-content class="mt-5" style="background:transparent;position:relative;">
      <v-container fluid style="padding:0px !important">
        <router-view></router-view>

        <!-- feedback button -->
        <v-fab-transition>
          <v-btn color="rgb(77, 144, 212)" dark fab fixed bottom right @click="showFeedbackDialog">
            <v-icon>feedback</v-icon>
          </v-btn>
        </v-fab-transition>

        <lingo_feedback></lingo_feedback>
      </v-container>
      <lingo_main_footer></lingo_main_footer>
    </v-content>

    <!--
    <v-footer :fixed="fixed" app class="ml-2">
      <span>&copy; 2019 Lingo AV</span>
    </v-footer>
    -->
  </v-layout>
</template>

<script>
import lingo_toolbar from "./Toolbar";
import lingo_drawer from "./Drawer";
import lingo_feedback from "./Feedback";
import lingo_main_footer from "./Footer";
import { Auth } from "./auth/cognito_auth";

export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        {
          icon: "keyboard",
          text: "Audio Generator",
          link: "/app/audio_generator"
        },
        {
          icon: "keyboard",
          text: "Video Generator",
          link: "/app/video_generator"
        },
        /* { icon: 'keyboard', text: 'Presets', link : '/app/generate' },
        { icon: 'keyboard', text: 'History', link : '/app/generate' }, */
        { icon: "keyboard", text: "Samples", link: "/app/gallery" }
      ],
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: "Lingo AV"
    };
  },
  components: {
    lingo_toolbar,
    lingo_drawer,
    lingo_main_footer,
    lingo_feedback
  },
  methods: {
    logout() {
      Auth.logout();
    },
    showFeedbackDialog() {
      this.$store.commit(
        "setFeedbackDialog",
        !this.$store.getters.feedbackDialog
      );
    }
  },
  mounted() {
    let paypalScript = document.createElement("script");
    let paypalSdkURL =
      "https://www.paypal.com/sdk/js?client-id=" +
      process.env.VUE_APP_PAYPAL_CLIENT_ID;
    paypalScript.setAttribute("src", paypalSdkURL);
    document.head.appendChild(paypalScript);
  }
};
</script>
